import React, { useState, useEffect, createContext } from 'react'
import jwtDecode from 'jwt-decode'
import { useDispatch } from 'react-redux'
// import { changeUser, logout } from '../redux/userSlice'
import { useNavigate } from 'react-router-dom'
import { api } from '../services/api'
import { saveHistoryAccess } from '../services/saveHistoryAccess'
import { createSession } from '../services/loginApi'
import { encryptString } from '../services/crypto'

export const AuthContext = createContext()

/* eslint-disable react/prop-types */
export const AuthProvider = ({ children }) => {
  const navigate = useNavigate()
  const [token, setToken] = useState(null)
  const [loading, setLoading] = useState(true)
  const dispatch = useDispatch()

  useEffect(() => {
    const _token = localStorage.getItem('token')

    if (_token) {
      setToken(_token)
      api.defaults.headers.Authorization = `Bearer ${token}`
    } else {
      logoutSystem('')
    }

    setLoading(false)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const login = async (email, password) => {
    if (email && password) {
      try {
        const response = await createSession(email, password)

        if (response.data.error === undefined) {
          if (+response.data.user.indUsuarioInativo === 1) return 'Usuário inativo.'
          // console.log('login-info:', response.data)
          const encryptedString = await encryptString(JSON.stringify(response.data))
          localStorage.setItem('persist', encryptedString)
          // const loggedUser = response.data.user
          // dispatch(changeUser({ token: response.data.token, data: loggedUser }))
          localStorage.setItem('token', response.data.token)
          localStorage.setItem('tempUserId', response.data.user.id)

          api.defaults.headers.Authorization = `Bearer ${response.data.token}`
          setToken(response.data.token)

          return response.data.message
        } else {
          return response.data.error
        }
      } catch (err) {
        console.log('err: ', err)
        return 'Algo deu errado!'
      }
    }

    return 'Por favor, preencha todos os campos.'
  }

  const logoutSystem = async (origin) => {
    if (token && origin === 'btn') {
      // const infoToken = jwtDecode(token)
      // const result = await saveHistoryAccess(infoToken.userId, 'Logout', 'logout')
      // if (result === 'Histórico processado.') {
      setToken(null)
      // dispatch(logout())
      localStorage.removeItem('token')
      localStorage.removeItem('persist')
      api.defaults.headers.Authorization = null
      // localStorage.setItem('refreshPage', true)
      navigate('/login')
      return true
      // } else {
      //   return false
      // }
    } else {
      setToken(null)
      // dispatch(logout())
      localStorage.removeItem('token')
      localStorage.removeItem('persist')
      api.defaults.headers.Authorization = null
      // localStorage.setItem('refreshPage', true)
      navigate('/login')
    }
  }

  return (
    <AuthContext.Provider value={{ authenticated: !!token, loading, login, logoutSystem }}>
      {children}
    </AuthContext.Provider>
  )
}
